module.exports = __webpack_public_path__ + "static/media/tutorial_icon_dark.76fa56a2.svg";